import { Box, Text } from 'grommet';

export type StatusTone = 'ok' | 'warning' | 'danger' | 'neutral';

/** "producer_signed" -> "Producer signed" */
export const formatStatus = (status?: string | null) => {
  const text = (status ?? '').replace(/_/g, ' ').trim().toLowerCase();
  return text.charAt(0).toUpperCase() + text.slice(1);
};

export type StatusPillProps = {
  /** Shown as is when a string with spaces or capitals; raw statuses go through formatStatus */
  label: string;
  tone?: StatusTone;
};

/** A status as a tinted pill with dark text, readable at a glance (white on orange wasn't) */
export const StatusPill = ({ label, tone = 'neutral' }: StatusPillProps) => (
  <Box
    background={`pill-${tone}-bg`}
    round="999px"
    pad={{ horizontal: '10px', vertical: '3px' }}
    width="fit-content"
    flex={false}
  >
    <Text size="13px" weight={600} color={`pill-${tone}-text`} style={{ whiteSpace: 'nowrap' }}>
      {/^[a-z_]+$/.test(label) ? formatStatus(label) : label}
    </Text>
  </Box>
);
